/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

const universal = require('react-universal-component').default;

export const viewDictionary = {};

viewDictionary['__local__|__local__|modules|fhi-product-collection|fhi-product-collection'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         'partner/modules/fhi-product-collection/fhi-product-collection.view.tsx'),
         {
            chunkName: () => 'partner-modules-fhi-product-collection-fhi-product-collection.view.tsx',
            ignoreBabelRename: true
         }
    )};
viewDictionary['__local__|__local__|modules|fhi-wishlist-items|fhi-wishlist-items'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         'partner/modules/fhi-wishlist-items/fhi-wishlist-items.view.tsx'),
         {
            chunkName: () => 'partner-modules-fhi-wishlist-items-fhi-wishlist-items.view.tsx',
            ignoreBabelRename: true
         }
    )};
viewDictionary['__local__|__local__|themes|fhi|views|media-gallery'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         'partner/themes/fhi/views/media-gallery.view.tsx'),
         {
            chunkName: () => 'partner-themes-fhi-views-media-gallery.view.tsx',
            ignoreBabelRename: true
         }
    )};
viewDictionary['__local__|__local__|themes|fhi|views|order-details'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         'partner/themes/fhi/views/order-details.view.tsx'),
         {
            chunkName: () => 'partner-themes-fhi-views-order-details.view.tsx',
            ignoreBabelRename: true
         }
    )};
viewDictionary['__local__|__local__|themes|fhi|views|order-history'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         'partner/themes/fhi/views/order-history.view.tsx'),
         {
            chunkName: () => 'partner-themes-fhi-views-order-history.view.tsx',
            ignoreBabelRename: true
         }
    )};
viewDictionary['__local__|__local__|themes|fhi|views|search-result-container'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         'partner/themes/fhi/views/search-result-container.view.tsx'),
         {
            chunkName: () => 'partner-themes-fhi-views-search-result-container.view.tsx',
            ignoreBabelRename: true
         }
    )};
viewDictionary['__local__|__local__|themes|fhi|views|search'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         'partner/themes/fhi/views/search.view.tsx'),
         {
            chunkName: () => 'partner-themes-fhi-views-search.view.tsx',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|accordion|modules|accordion-item|accordion-item'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion-item/accordion-item.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-accordion-dist-lib-modules-accordion-item-accordion-item.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|accordion|modules|accordion|accordion'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion/accordion.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-accordion-dist-lib-modules-accordion-accordion.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|aad-generic|aad-generic'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/aad-generic/aad-generic.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-aad-generic-aad-generic.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-address-tile|account-address-tile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-address-tile/account-address-tile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-address-tile-account-address-tile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-customer-balance-tile|account-customer-balance-tile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance-tile/account-customer-balance-tile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-customer-balance-tile-account-customer-balance-tile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-customer-balance|account-customer-balance'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance/account-customer-balance.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-customer-balance-account-customer-balance.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-generic-tile|account-generic-tile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-generic-tile/account-generic-tile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-generic-tile-account-generic-tile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-loyalty-tile|account-loyalty-tile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty-tile/account-loyalty-tile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-loyalty-tile-account-loyalty-tile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-loyalty|account-loyalty'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty/account-loyalty.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-loyalty-account-loyalty.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-order-templates-tile|account-order-templates-tile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-order-templates-tile/account-order-templates-tile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-order-templates-tile-account-order-templates-tile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-profile-edit|account-profile-edit'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile-edit/account-profile-edit.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-profile-edit-account-profile-edit.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-profile|account-profile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile/account-profile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-profile-account-profile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-welcome-tile|account-welcome-tile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-welcome-tile/account-welcome-tile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-welcome-tile-account-welcome-tile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-wishlist-tile|account-wishlist-tile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-wishlist-tile/account-wishlist-tile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-account-wishlist-tile-account-wishlist-tile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|loyalty-sign-up|loyalty-sign-up'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-sign-up/loyalty-sign-up.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-loyalty-sign-up-loyalty-sign-up.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|loyalty-terms|loyalty-terms'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-terms/loyalty-terms.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-loyalty-terms-loyalty-terms.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|organization-users-tile|organization-users-tile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/organization-users-tile/organization-users-tile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-organization-users-tile-organization-users-tile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|password-reset-verification|password-reset-verification'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset-verification/password-reset-verification.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-password-reset-verification-password-reset-verification.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|password-reset|password-reset'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset/password-reset.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-password-reset-password-reset.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|sign-in|sign-in'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in/sign-in.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-sign-in-sign-in.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|account-management|modules|sign-up|sign-up'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up/sign-up.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-account-management-dist-lib-modules-sign-up-sign-up.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|address|modules|account-management-address|account-management-address'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/address/dist/lib/modules/account-management-address/account-management-address.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-address-dist-lib-modules-account-management-address-account-management-address.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|address|modules|business-account-address|business-account-address'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/address/dist/lib/modules/business-account-address/business-account-address.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-address-dist-lib-modules-business-account-address-business-account-address.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|address|modules|checkout-billing-address|checkout-billing-address'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-billing-address/checkout-billing-address.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-address-dist-lib-modules-checkout-billing-address-checkout-billing-address.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|address|modules|checkout-shipping-address|checkout-shipping-address'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-shipping-address/checkout-shipping-address.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-address-dist-lib-modules-checkout-shipping-address-checkout-shipping-address.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|breadcrumb|modules|breadcrumb|breadcrumb'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/breadcrumb/dist/lib/modules/breadcrumb/breadcrumb.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-breadcrumb-dist-lib-modules-breadcrumb-breadcrumb.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|business-account-management|modules|business-sign-up|business-sign-up'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-business-account-management-dist-lib-modules-business-sign-up-business-sign-up.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|business-organization-list|modules|business-organization-list|business-organization-list'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/business-organization-list/dist/lib/modules/business-organization-list/business-organization-list.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-business-organization-list-dist-lib-modules-business-organization-list-business-organization-list.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|buybox|modules|buybox|buybox'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/buybox/dist/lib/modules/buybox/buybox.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-buybox-dist-lib-modules-buybox-buybox.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|carousel|modules|carousel|carousel'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/carousel/dist/lib/modules/carousel/carousel.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-carousel-dist-lib-modules-carousel-carousel.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|cart|modules|cart-icon|cart-icon'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/cart/dist/lib/modules/cart-icon/cart-icon.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-cart-dist-lib-modules-cart-icon-cart-icon.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|cart|modules|cart|cart'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/cart/dist/lib/modules/cart/cart.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-cart-dist-lib-modules-cart-cart.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-customer-account-payment|checkout-customer-account-payment'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-customer-account-payment/checkout-customer-account-payment.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-customer-account-payment-checkout-customer-account-payment.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-delivery-options|checkout-delivery-options'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-delivery-options/checkout-delivery-options.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-delivery-options-checkout-delivery-options.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-gift-card|checkout-gift-card'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-gift-card/checkout-gift-card.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-gift-card-checkout-gift-card.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-guest-profile|checkout-guest-profile'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-guest-profile/checkout-guest-profile.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-guest-profile-checkout-guest-profile.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-loyalty|checkout-loyalty'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-loyalty/checkout-loyalty.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-loyalty-checkout-loyalty.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-payment-instrument|checkout-payment-instrument'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/checkout-payment-instrument.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-payment-instrument-checkout-payment-instrument.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-pickup|checkout-pickup'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-pickup/checkout-pickup.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-pickup-checkout-pickup.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-section-container|checkout-section-container'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-section-container/checkout-section-container.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-section-container-checkout-section-container.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-terms-and-conditions|checkout-terms-and-conditions'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-terms-and-conditions/checkout-terms-and-conditions.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-terms-and-conditions-checkout-terms-and-conditions.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout|checkout'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/checkout.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-checkout-checkout.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|checkout|modules|gift-card-balance-check|gift-card-balance-check'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/checkout/dist/lib/modules/gift-card-balance-check/gift-card-balance-check.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-checkout-dist-lib-modules-gift-card-balance-check-gift-card-balance-check.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|content-block|modules|content-block|content-block'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/content-block/dist/lib/modules/content-block/content-block.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-content-block-dist-lib-modules-content-block-content-block.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|cookie-compliance|modules|cookie-compliance|cookie-compliance'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-cookie-compliance-dist-lib-modules-cookie-compliance-cookie-compliance.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|buybox'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/buybox.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-buybox.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|cart'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/cart.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-cart.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|header'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/header.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-header.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|navigation-menu'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/navigation-menu.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-navigation-menu.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|order-details'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/order-details.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-order-details.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|order-history'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/order-history.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-order-history.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|ratings-histogram'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/ratings-histogram.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-ratings-histogram.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|reviews-list'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/reviews-list.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-reviews-list.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|search-result-container'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/search-result-container.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-search-result-container.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|footer|modules|footer-category|footer-category'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-category/footer-category.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-footer-dist-lib-modules-footer-category-footer-category.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|footer|modules|footer-item|footer-item'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-item/footer-item.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-footer-dist-lib-modules-footer-item-footer-item.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|header|modules|header|header'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/header/dist/lib/modules/header/header.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-header-dist-lib-modules-header-header.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|iframe|modules|iframe|iframe'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/iframe/dist/lib/modules/iframe/iframe.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-iframe-dist-lib-modules-iframe-iframe.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|map|modules|map|map'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/map/dist/lib/modules/map/map.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-map-dist-lib-modules-map-map.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|media-gallery|modules|media-gallery|media-gallery'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/media-gallery/dist/lib/modules/media-gallery/media-gallery.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-media-gallery-dist-lib-modules-media-gallery-media-gallery.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|navigation-menu|modules|navigation-menu|navigation-menu'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/navigation-menu/dist/lib/modules/navigation-menu/navigation-menu.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-navigation-menu-dist-lib-modules-navigation-menu-navigation-menu.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|order-management|modules|checkout-order-confirmation|checkout-order-confirmation'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/order-management/dist/lib/modules/checkout-order-confirmation/checkout-order-confirmation.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-checkout-order-confirmation-checkout-order-confirmation.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-confirmation|order-confirmation'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-confirmation/order-confirmation.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-order-confirmation-order-confirmation.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-details|order-details'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-details/order-details.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-order-details-order-details.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-history|order-history'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history/order-history.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-order-management-dist-lib-modules-order-history-order-history.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|order-template|modules|order-template-list|order-template-list'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template-list/order-template-list.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-order-template-dist-lib-modules-order-template-list-order-template-list.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|order-template|modules|order-template|order-template'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/order-template.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-order-template-dist-lib-modules-order-template-order-template.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|product-collection|modules|product-collection|product-collection'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/product-collection/dist/lib/modules/product-collection/product-collection.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-product-collection-dist-lib-modules-product-collection-product-collection.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|product-specification|modules|product-specification|product-specification'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/product-specification/dist/lib/modules/product-specification/product-specification.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-product-specification-dist-lib-modules-product-specification-product-specification.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|promo-banner|modules|promo-banner|promo-banner'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner/promo-banner.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-promo-banner-dist-lib-modules-promo-banner-promo-banner.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|ratings-histogram|ratings-histogram'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/ratings-histogram/ratings-histogram.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-ratings-reviews-dist-lib-modules-ratings-histogram-ratings-histogram.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|reviews-list|reviews-list'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/reviews-list/reviews-list.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-ratings-reviews-dist-lib-modules-reviews-list-reviews-list.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|write-review|write-review'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/write-review/write-review.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-ratings-reviews-dist-lib-modules-write-review-write-review.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|search-result-container|modules|search-result-container|search-result-container'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/search-result-container.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-search-result-container-dist-lib-modules-search-result-container-search-result-container.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|search|modules|search|search'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/search/dist/lib/modules/search/search.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-search-dist-lib-modules-search-search.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|site-picker|modules|site-picker|site-picker'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/site-picker/dist/lib/modules/site-picker/site-picker.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-site-picker-dist-lib-modules-site-picker-site-picker.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|social-share|modules|social-share-item|social-share-item'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share-item/social-share-item.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-social-share-dist-lib-modules-social-share-item-social-share-item.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|social-share|modules|social-share|social-share'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share/social-share.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-social-share-dist-lib-modules-social-share-social-share.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|spacer|modules|spacer|spacer'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/spacer/dist/lib/modules/spacer/spacer.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-spacer-dist-lib-modules-spacer-spacer.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|store-selector|modules|store-selector|store-selector'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/store-selector/dist/lib/modules/store-selector/store-selector.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-store-selector-dist-lib-modules-store-selector-store-selector.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|tab|modules|tab-item|tab-item'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/tab/dist/lib/modules/tab-item/tab-item.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-tab-dist-lib-modules-tab-item-tab-item.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|tab|modules|tab|tab'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/tab/dist/lib/modules/tab/tab.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-tab-dist-lib-modules-tab-tab.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|text-block|modules|text-block|text-block'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block/text-block.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-text-block-dist-lib-modules-text-block-text-block.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|video-player|modules|video-player|video-player'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player/video-player.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-video-player-dist-lib-modules-video-player-video-player.view.js',
            ignoreBabelRename: true
         }
    )};
viewDictionary['@msdyn365-commerce-modules|wishlist|modules|wishlist-items|wishlist-items'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/wishlist-items.view.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-wishlist-dist-lib-modules-wishlist-items-wishlist-items.view.js',
            ignoreBabelRename: true
         }
    )};